import { defineStore } from "pinia";
import { doctors } from '@/data/doctors';
import { resetForm } from "@/functions/appointment.js";
import axiosClient from "../axios.js";

export const useDoctorStore = defineStore("doctor", {
    state: () => ({
        // ==================== states used on home page and its relation
        doctors: doctors,
        doctor: null,
        selectedDoctor: null,
        selectedDay: null,
        schedules: null,
        submitProcess: null
    }),
    getters: {
        // ==========
    },
    actions: {
        // ==================== actions used on home page and its relation
        setDoctor(id){
            for(var i = 0; i < doctors.length; i++){
                if(doctors[i].id == id){
                    this.doctor = doctors[i];
                }
            }
        },
        selectDoctor(id){
            this.schedules = null;
            for(var i = 0; i < doctors.length; i++){
                if(doctors[i].id == id){
                    this.selectedDoctor = doctors[i];
                    if(this.selectedDay){
                        for(var j = 0; j < doctors[i].schedules.length; j++){
                            if(doctors[i].schedules[j].id == this.selectedDay){
                                this.schedules = doctors[i].schedules[j].artime;
                            }
                        }
                    }
                }
            }
            this.setDoctor(id);
            // console.log(this.selectedDay);
            // console.log(this.schedules);
            return this.selectedDoctor;
        },
        selectDay(date){
            this.schedules = null;
            const d = new Date(date);
            this.selectedDay = d.getDay();
            if(this.selectedDoctor){
                for(var i = 0; i < this.selectedDoctor.schedules.length; i++){
                    if(this.selectedDoctor.schedules[i].id == d.getDay()){
                        this.schedules = this.selectedDoctor.schedules[i].artime;
                    }
                }
            }
            // console.log(this.selectedDoctor);
            // console.log(this.selectedDay);
            // console.log(this.schedules);
        },
        prevDoctor(){
            const cd = this.doctor.id;
            if((cd - 1) < 0){
                this.setDoctor((doctors.length - 1));
            }else{
                this.setDoctor(cd - 1);
            }
        },
        nextDoctor(){
            const cd = this.doctor.id;
            if(doctors.length > (cd + 1)){
                this.setDoctor(cd + 1);
            }else{
                this.setDoctor(0);
            }
            // console.log(cd + 1);
        },
        async submitAppointment(params){
            this.submitProcess = 1;
            const response = await axiosClient.post(`morula/make-appointment`, params);
            if(response.data.status == 1){
                window.open('https://wa.me/6281295071800?text=' + params.message);
                this.schedules = null;
                resetForm();
                this.submitProcess = null;
            }else{
                this.submitProcess = null;
            }
            // console.log(response);
        }
    }
});